

import crypto from 'crypto'

const key = crypto
    .createHash('sha512')
    .update(process.env.REACT_APP_SECRET_KEY_EN)
    .digest('hex')
    .substring(0, 32)

const encryptionIV = crypto
    .createHash('sha512')
    .update(process.env.REACT_APP_SECRET_IV)
    .digest('hex')
    .substring(0, 16)

const EncryptData = (data: string) => {
    const cipher = crypto.createCipheriv(process.env.REACT_APP_ENCRYPTION_METHOD, key, encryptionIV)
    return Buffer.from(cipher.update(data, 'utf8', 'hex') + cipher.final('hex')).toString('base64')
}

const DecryptData = (data: string) => {
    const buff = Buffer.from(data, 'base64')
    const decipher = crypto.createDecipheriv(process.env.REACT_APP_ENCRYPTION_METHOD, key, encryptionIV)
    return (decipher.update(buff.toString('utf8'), 'hex', 'utf8') + decipher.final('utf8'))
}

const roundToTwo = (value: number, decimals = 2): number => (Number(Math.round(parseFloat(value.toString() + 'e' + decimals)) + 'e-' + decimals));
const typeMoney: { [key: string]: string } = {
    '¢': 'es-CR',
    'U$': 'en-US'
}
const typeMoney2: { [key: string]: string } = {
    '¢': 'CRC',
    'U$': 'USD'
}

const formatCurrency = (currency: string = 'U$', value: number) => new Intl.NumberFormat(typeMoney[currency.trim()], { style: 'currency', currency: typeMoney2[currency.trim()], currencyDisplay: 'symbol' }).format(value);

const validPrima = (value: any): number => {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
}

const GetResumenRate = ({ plan, lstRates, lstCoverageExt, idDiscount, catQuotas, nQuotas, sumInsured }: IPropsResumenRate) => {
    let coveragesDetail: Array<IRatesTable> = [];
    const currency = plan.moneda.trim();

    console.log('GetResumenRate', plan, lstRates, lstCoverageExt, idDiscount, catQuotas, nQuotas, sumInsured);

    let financing: number = 0;
    let desc = 0;
    let taxAcum = 0;
    let cobBonusDE = 0;

    lstRates.map((rate: IRates) => {
        let nameCover = lstCoverageExt.find(x => x.idCob === rate.idCob);
        let taxPercentage = GetTaxPercentage(nameCover ?? {} as ICoveragesExt, plan)

        let prima = validPrima(rate.prima);



        if (nameCover !== undefined) {
            let insuredMount = prima * ((rate.pRecargo / 100) + 1);
            let det: IRatesTable = {
                idcob: rate.idCob,
                name: nameCover.nombre,
                insured: formatCurrency(currency, insuredMount),
                sa: rate.sa,
                value: formatCurrency(currency, parseFloat(rate.sa))
            };
            coveragesDetail.push(det);


            let porcenDescount = 0;
            if (rate.descuentos.length > 0) {
                let descAp = rate.descuentos.find((x: any) => x.codigoDescuento === idDiscount)
                if (descAp !== undefined) {
                    porcenDescount = descAp.porcentaje;
                }
                else {
                    porcenDescount = rate.descuentos[0].porcentaje;
                }
            }

            let montoDescuentoCob = 0;
            let impuesto = 0

            let primaRecargo = roundToTwo((roundToTwo(prima) + roundToTwo((prima * rate.pRecargo) / 100)));
            if (porcenDescount > 0) {
                montoDescuentoCob = roundToTwo(primaRecargo * (porcenDescount / 100))
                desc = roundToTwo(desc + montoDescuentoCob)
            }

            if (nameCover.bImpuesto1) {
                let primaDesc = roundToTwo(primaRecargo - montoDescuentoCob, 2)
                impuesto = roundToTwo(primaDesc * roundToTwo((GetTaxPercentage(nameCover, plan).tax1 / 100)));
                taxAcum = roundToTwo(taxAcum + impuesto);
                cobBonusDE = roundToTwo(cobBonusDE + prima)
            }

        }
    });


    let rightEmission: number = roundToTwo(cobBonusDE * (plan.porcentajeGasto / 100));
    if (rightEmission < plan.gastoMontoMinimo)
        rightEmission = plan.gastoMontoMinimo;
    if (rightEmission > plan.gastoMontoMaximo)
        rightEmission = plan.gastoMontoMaximo;

    let taxFinancing = plan.intereses ?? undefined;

    let bonus = lstRates.reduce((accumulator, x) => {
        const primaCalculada = roundToTwo(validPrima(x.prima)) + roundToTwo((validPrima(x.prima) * x.pRecargo) / 100);
        accumulator += primaCalculada;
        return roundToTwo(accumulator);
    }, 0);

    let bonusDE = roundToTwo(cobBonusDE - desc);
    let bonus2 = roundToTwo(bonus - desc);

    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === (nQuotas === '' ? 0 : parseInt(nQuotas)));
        if (taxP !== undefined)
            financing = roundToTwo((bonus2 * (parseFloat(taxP.porcentajeInteres) / 100)));
    }



    let tax = taxAcum;
    let total = roundToTwo(bonus2 + tax + financing + rightEmission);

    let catBonusFrecuenia: Array<ICatalog> = catQuotas.map((x: ICatalog) => {
        return {
            text: x.text,
            value: formatCurrency(currency, (bonus2 + tax + GetFinancing(taxFinancing, bonus2, x.value) + rightEmission) / parseInt(x.value))
        } as ICatalog
    })


    let result: IRatesResumen = {
        coveragesDetail: coveragesDetail,
        bonus: bonus,
        desc: desc,
        bonus2: bonus2,
        tax: tax,
        financing: financing,
        total: total,
        bonusDE: bonusDE,
        rightEmission: rightEmission,

        bonusStr: formatCurrency(currency, bonus),
        descStr: formatCurrency(currency, desc),
        bonus2Str: formatCurrency(currency, bonus2),
        taxStr: formatCurrency(currency, tax),
        financingStr: formatCurrency(currency, financing),
        totalStr: formatCurrency(currency, total),

        bonusAnnual: '',
        bonusSemester: '',
        bonusQuarterly: '',
        bonusMonthly: '',
        bonusFrecuencia: 0,
        bonusFrecuenciaStr: formatCurrency(currency, (bonus2 + tax + GetFinancing(taxFinancing, bonus2, nQuotas) + rightEmission) / parseInt(nQuotas)),

        rightEmissionsStr: formatCurrency(currency, rightEmission),
        bonusfrequency: catBonusFrecuenia,
        sumInsured: sumInsured,
        sumInsuredStr: formatCurrency(currency, roundToTwo(parseFloat(sumInsured)))
    }

    console.log(result);

    return result;
}

const GetFinancing = (taxFinancing: any, bonus: number, quotas: string = '') => {
    let financing = 0
    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === (quotas === '' ? 0 : parseInt(quotas)));
        if (taxP !== undefined)
            financing = roundToTwo((bonus * (parseFloat(taxP.porcentajeInteres) / 100)));
    }
    return financing;
}

const GetTaxPercentage = (coverage: ICoveragesExt, plan: IPlanConfig) => {
    const { bImpuesto1, pImpuesto1, bImpuesto2, pImpuesto2 } = coverage;
    const { interes, interes2 } = plan.impuestos;
    return {
        tax1: bImpuesto1 ? (pImpuesto1 ?? interes) : 0,
        tax2: bImpuesto2 ? (pImpuesto2 ?? interes2) : 0
    };
};

const CalculateAge = (date: Date) => {

    const today = new Date();
    const birthDate = new Date(date);

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

const GetNewGuid = (type: number = 0) => {
    if (type === 1)
        return 'xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r: number = Math.random() * 16 | 0;
            const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r: number = Math.random() * 16 | 0;
        const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const ValidateEmail = (value: string): IEmailValidationResult => {
    const trimmedValue = value.trim();

    // Regla 1: No debe contener espacios
    if (/\s/.test(trimmedValue)) {
        return {
            isValid: false,
            errorMessage: 'El correo no debe contener espacios en blanco.'
        };
    }

    // Regla 2: Solo un @
    const atCount = (trimmedValue.match(/@/g) || []).length;
    if (atCount !== 1) {
        return {
            isValid: false,
            errorMessage: 'El correo solo debe contener un @.'
        };
    }

    const [localPart, domainPart] = trimmedValue.split('@');

    // Regla 3: Debe tener punto (.) después del @
    if (!domainPart || !domainPart.includes('.')) {
        return {
            isValid: false,
            errorMessage: 'El dominio debe contener al menos un punto (.) después de @.'
        };
    }

    // Regla 4: Caracteres permitidos
    const allowedCharsRegex = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+$/;
    if (!allowedCharsRegex.test(trimmedValue)) {
        return {
            isValid: false,
            errorMessage: 'El correo solo puede contener letras, números y los siguientes caracteres especiales: ., -, _ y @, tampoco debe contener tildes ni comillas.'
        };
    }

    // Regla 5: No caracteres especiales como tildes, comillas, etc.
    const forbiddenCharsRegex = /[áéíóúÁÉÍÓÚ"'`¿?!¡]/;
    if (forbiddenCharsRegex.test(trimmedValue)) {
        return {
            isValid: false,
            errorMessage: 'El correo no debe contener caracteres especiales como tildes, comillas o signos de puntuación adicionales.'
        };
    }

    // Regla 6: El dominio debe terminar en .com, .net, .org, etc. (mínimo 2 caracteres después del punto final)
    const domainParts = domainPart.split('.');
    const lastPart = domainParts[domainParts.length - 1];
    if (!lastPart || lastPart.length < 2) {
        return {
            isValid: false,
            errorMessage: 'El dominio del correo debe ser válido (ejemplo: .com, .net, .org).'
        };
    }

    return {
        isValid: true,
        errorMessage: ''
    };
};

const BuildCardNum = (tarjeta: string) => {
    if (tarjeta.length < 4) {
        return tarjeta;
    }
    const ultimos4 = tarjeta.slice(-4);
    const oculto = '*'.repeat(tarjeta.length - 4);
    return oculto + ultimos4;
}

const GetHour = (date: Date) => {
    let hora = date.getHours();
    const minutos = date.getMinutes().toString().padStart(2, '0');
    const segundos = date.getSeconds().toString().padStart(2, '0');

    const ampm = hora >= 12 ? 'PM' : 'AM';

    hora = hora % 12;
    hora = hora ? hora : 12;

    return `${hora}:${minutos}:${segundos} ${ampm}`;
}

function ValidateExpirationDate(expirationDate: string): string | null {

    const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;

    if (!regex.test(expirationDate)) {
        return "Formato inválido. Use MM/YY.";
    }

    const [mesStr, anioStr] = expirationDate.split('/');
    const mes: number = parseInt(mesStr, 10);
    const anio: number = parseInt(anioStr, 10);

    const fechaActual: Date = new Date();
    const anioActual: number = fechaActual.getFullYear() % 100;
    const mesActual: number = fechaActual.getMonth() + 1;

    const fechaExpiracion: Date = new Date(2000 + anio, mes);
    if (fechaExpiracion <= fechaActual) {
        return "La tarjeta está expirada.";
    }
    return null;
}

export {
    EncryptData,
    DecryptData,
    GetResumenRate,
    CalculateAge,
    formatCurrency,
    GetNewGuid,
    roundToTwo,
    ValidateEmail,
    BuildCardNum,
    GetHour,
    ValidateExpirationDate
}